export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    // [{value:'',label:''}]
    users: {
      type: Array,
      default: () => []
    },
    // [{value:'',label:''}]
    topics: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    text() {
      if (!this.value) return this.emptyText;
      const topicText = this.parseTopic(this.value);
      return this.parseUser(topicText);
    }
  },
  methods: {
    parseTopic(text = '') {
      // 话题
      if (!text) return text;
      const pattern = /&&#&&/;
      for (let index = 0; pattern.test(text); index++) {
        const item = this.topics[index] || {};
        text = text.replace(pattern, `<topic data-id="${item.value}">#${item.label}#</topic>`);
      }
      return text;
    },
    parseUser(text = '') {
      // @用户
      if (!text) return text;
      const pattern = /&&_&&/;
      for (let index = 0; pattern.test(text); index++) {
        const item = this.users[index] || {};
        text = text.replace(pattern, `<user data-id="${item.value}">@${item.label}</user>`);
      }
      return text;
    },
    getElementByTag(e, tagName = 'A') {
      let target = e.target;
      while (target.tagName && target.tagName.toUpperCase() !== tagName && target.parentNode != null) {
        target = target.parentNode;
      }
      if (!target.tagName) return null;
      return target;
    },
    handleClick(e) {
      const target = this.getElementByTag(e, 'TOPIC') || this.getElementByTag(e, 'USER');
      if (!target) {
        return;
      }
      this.$emit('link', target);
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};